import React from 'react';
import cn from 'classnames';

import TooltipForReceptionist from 'components/TooltipForReceptionist';
import IN from 'constants/in';
import createNodeKey from 'utils/react/createNodeKey.util';

import ServiceItemComponent from 'settings/page-elements/dropdown/ServiceItem';
import Switcher from 'settings/page-elements/Switcher';

import CN from './ServiceList.module.scss';

class ServiceList extends React.Component {
  constructor(props) {
    super(props);
    let isChecked = false;
    for (let i = 0; i < props.services.length; i += 1) {
      if (props.services[i].is_online) {
        isChecked = true;
        break;
      }
    }
    this.state = {
      isChecked,
      category_services: props.category_services,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    let isChecked = false;
    for (let i = 0; i < nextProps.services.length; i += 1) {
      if (nextProps.services[i].is_online) {
        isChecked = true;
        break;
      }
    }
    if (isChecked !== this.state.isChecked) {
      this.setState({ isChecked });
    }
    if (nextProps.category_services) {
      this.setState({ category_services: nextProps.category_services });
    }
  }

  onSwitcherClick = (value) => {
    this.props.onSwitcherClick(this.props.stylistId, this.props.categoryName, value);
  };
  onCheckboxClick = (stylistId, serviceId, value) => {
    this.props.onCheckboxClick(stylistId, serviceId, value);
  };
  discard = () => {
    this.setState({ isChecked: !this.state.isChecked });
  };
  confirm = () => {
    this.setState({ isChecked: !this.state.isChecked });
  };

  render() {
    const componentClasses = cn({
      [CN.component]: true,
      [CN.darkMode]: this.props.isDarkMode,
      [CN.inactive]: !this.state.isChecked,
    });

    return (
      <div data-bem="ServiceList" className={componentClasses}>
        <div className={CN.listHeading}>
          <span className={CN.title}>{this.props.categoryName}</span>
          <div className={CN.relative}>
            <Switcher
              isChecked={this.state.isChecked}
              checkId={`${this.props.stylistId}x${this.props.categoryName}`}
              onCheckboxClick={this.onSwitcherClick}
            />
            <TooltipForReceptionist where={IN.serviceSwitcher} />
          </div>
        </div>

        <div className={CN.servicesContainer}>
          {this.props.services.map((service) => {
            let description = '';
            this.state.category_services.map((c) => {
              const serArr = c.services.filter((s) => s.id === service.service_id);
              if (serArr.length > 0) {
                // eslint-disable-next-line prefer-destructuring
                description = serArr[0].description;
                serArr.splice(0, 1);
              }
              return null;
            });
            return (
              <div
                key={createNodeKey({ tag: service.service_id, unique: service.stylist_id })}
                className={CN.serviceItem}
              >
                <ServiceItemComponent
                  service={service}
                  onCheckboxClick={this.onCheckboxClick}
                  generalName={this.props.generalName}
                  description={description}
                />
                <TooltipForReceptionist where={IN.serviceItem} />
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default ServiceList;

// FIXME: Bug if we use the below Hoc declaration clicking on the checkboxes breaks,
// so I can't use the dark theme now

// const ServiceListHoc = withTheme()(ServiceList);
// export default ServiceListHoc;
